import {EsimPackage} from '@guestapp/sdk';
import {Checkbox} from '@guestapp/ui';
import {Controller, useFormContext} from 'react-hook-form';
import {FormTypes} from './types';

export const PackageCheckbox = ({esimPackage}: {esimPackage: EsimPackage}) => {
  const {control} = useFormContext<FormTypes>();

  return (
    <Controller
      name={`${esimPackage.package_id}.checked`}
      control={control}
      render={({field: {onChange, value, ...field}}) => (
        <Checkbox
          className="p-4 rounded-2xl border border-[hsl(var(--border))] bg-[var(--navigation-background)] [&>:nth-child(2)]:w-full"
          onChange={() => onChange(!value)}
          value={value}
          label={
            <span className="flex glap-2 text-sm font-semibold justify-between w-full">
              <span className="grow">{esimPackage.package_title}</span>
              <span className="shrink-0">{esimPackage.package_price}</span>
            </span>
          }
          {...field}
        />
      )}
    />
  );
};
